import type { PortfolioBacktest, PortfolioBacktestRefreshStatus } from '@einhaus/project314-types';

export type PortfolioRefreshFilter = 'all' | 'enabled' | 'paused' | 'off';

export function indexPortfolioRefreshStatuses(
    statuses: readonly PortfolioBacktestRefreshStatus[]
): Map<number, PortfolioBacktestRefreshStatus> {
    const byBacktest = new Map<number, PortfolioBacktestRefreshStatus>();
    for (const status of statuses) {
        byBacktest.set(status.baselineBacktestId, status);
    }
    return byBacktest;
}

export function resolvePortfolioRefreshStatus(
    backtest: Pick<PortfolioBacktest, 'id' | 'refreshBaselineBacktestId'>,
    statuses: ReadonlyMap<number, PortfolioBacktestRefreshStatus>
): PortfolioBacktestRefreshStatus | undefined {
    return statuses.get(backtest.refreshBaselineBacktestId ?? backtest.id);
}

export function matchesPortfolioRefreshFilter(status: PortfolioBacktestRefreshStatus | undefined, filter: PortfolioRefreshFilter): boolean {
    if (filter === 'all') return true;
    if (filter === 'off') return status === undefined;
    return filter === 'enabled' ? status?.isEnabled === true : status?.isEnabled === false;
}

export function describePortfolioRefreshStatus(status: PortfolioBacktestRefreshStatus | undefined): string {
    if (!status) return 'Off';
    const enabled = status.isEnabled ? 'On' : 'Paused';
    if (status.activeAttempt) return `${enabled} · Refreshing`;
    if (status.refreshRequestedDateTime) return `${enabled} · Requested`;
    return enabled;
}
